<template>
  <div style="min-width: 1260px;text-align: center;background: #eff1f4 !important;">
    <!-- 顶栏 -->
    <HeaderMain></HeaderMain>
    <!--顶部图片底部背景 -->
    <img id="app-search-top-banner" alt="pic" src="../../assets/img/search-background.png"/>
    <div id="app-search-body">
      <!-- 搜索框框 -->
      <div style="margin-top: 15px;">
        <el-input placeholder="请输入两位以上搜索关键字，暂不支持空格多关键词模糊搜索" v-model="searchKey" class="input-with-select"
                  style="height: 40px !important;" @keyup.enter.native="doSearchByClick()">
          <el-button slot="append" style="height: 45px !important;" icon="el-icon-search"
                     v-on:click="doSearchByClick()"></el-button>
        </el-input>
      </div>
      <!-- 搜索筛选框 -->
      <el-tabs id="app-search-result-body" type="border-card" :stretch="true">
        <!-- 开源课程 -->
        <el-tab-pane v-on:click="this.searchMode = 1">
            <span class="app-search-result-type-title" slot="label">
              <em class="margin-top-10-block"/>
              <em class="el-icon-video-play"></em>开源课程
              <em class="margin-bottom-10-block"/>
            </span>
          <!-- 主体 -->
          <SearchOpenCurriculum ref="SearchOpenCurriculum"></SearchOpenCurriculum>
        </el-tab-pane>
        <el-tab-pane disabled v-on:click="this.searchMode = 1">
          <!-- 最新资讯 -->
          <span class="app-search-result-type-title" slot="label">
              <em class="margin-top-10-block"/>
              <em class="el-icon-news"></em>最新资讯
              <em class="margin-bottom-10-block"/>
            </span>
          <!-- 主体 -->
          <SearchNews></SearchNews>
        </el-tab-pane>
        <el-tab-pane disabled v-on:click="this.searchMode = 1">
          <!-- 万物有灵 -->
          <span class="app-search-result-type-title" slot="label">
              <em class="margin-top-10-block"/>
              <em class="el-icon-loading"></em>万物有灵
              <em class="margin-bottom-10-block"/>
            </span>
          <!-- 主体 -->
          <SearchEveryThing></SearchEveryThing>
        </el-tab-pane>
        <el-tab-pane disabled v-on:click="this.searchMode = 1">
          <!-- 正版插件 -->
          <span class="app-search-result-type-title" slot="label">
              <em class="margin-top-10-block"/>
              <em class="el-icon-stopwatch"></em>正版插件
              <em class="margin-bottom-10-block"/>
            </span>
          <!-- 主体 -->
          <SearchPlugin></SearchPlugin>
        </el-tab-pane>
      </el-tabs>
      <!-- 搜索结果 -->
      <div id="app-search-rs">
        <CurriculumBaseList :list-info="searchRsList" v-loading="loaded"></CurriculumBaseList>
      </div>
      <!-- 底部Banner -->
      <img id="app-search-banner" alt="pic" src="https://img.blendermagic.cn/new/search.jpg"/>
    </div>
  </div>
</template>

<script>

import SearchOpenCurriculum from "@/views/search/components/SearchOpenCurriculum";
import SearchNews from "@/views/search/components/SearchNews";
import SearchEveryThing from "@/views/search/components/SearchEveryThing";
import SearchPlugin from "@/views/search/components/SearchPlugin";
import CurriculumBaseList from "@/views/share/CurriculumBaseList";
import {Message, Notification} from "element-ui";
import HeaderMain from "@/views/share/HeaderMain";

export default {
  name: "Search",
  components: {
    HeaderMain,
    CurriculumBaseList,
    SearchPlugin,
    SearchEveryThing,
    SearchNews,
    SearchOpenCurriculum
  },
  data() {
    return {
      searchKey: '',
      searchMode: 1,
      searchRsList: [],
      loaded: true,
    }
  },
  mounted() {
    this.doSearch();
    document.title = "斑斓魔法CG-搜索"
  },
  watch: {
    searchKey: function (newVal) {
      if (newVal.length === 0) {
        this.doSearch();
      }
    }
  },
  methods: {
    doSearchByClick() {
      if (this.searchKey < 2) {
        Message({
          showClose: false,
          message: '关键词过短,请重新输入',
          type: 'warning'
        });
        return;
      }
      this.doSearch();
    },
    doSearch() {
      this.loaded = true;
      let intervalId;
      switch (this.searchMode) {
        case 1:
          this.$refs.SearchOpenCurriculum.doCurriculumSearch(this.searchKey);
          intervalId = setInterval(() => {
            for (let time = 0; time < 40; time++) {
              if (this.$refs.SearchOpenCurriculum.searchFlag) {
                this.searchRsList = this.$refs.SearchOpenCurriculum.searchRs;
                this.loaded = false;
                clearInterval(intervalId);
                return;
              }
            }
            Notification.error({
              title: '出错了（；´д｀）ゞ',
              message: '连接服务器超时'
            });
            clearInterval(intervalId);
          }, 1000);
          break;
        case 2:
        case 3:
        case 4:
      }
    }
  }
}
</script>

<style scoped>

#app-search-top-banner {
  width: 100%;
  height: 200px;
  min-width: 1260px;
  object-fit: cover;
}

#app-search-body {
  position: relative;
  top: -87px;
  width: 1160px;
  margin: auto;
  /*background: #00aa55;*/
}

#app-search-result-body {
  margin-top: 50px;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.10);
}

.app-search-result-type-title {
  font-size: 20px;
  letter-spacing: 5px;
}

#app-search-rs {
  background: #FFFFFF;
  margin-top: 15px;
  border-radius: 5px;
  padding-bottom: 25px;
  /*height: 500px;*/
  /*box-shadow: 0 0 15px rgba(0, 0, 0, 0.10);*/
}

#app-search-banner {
  position: relative;
  top: 30px;
  height: 100px;
}

</style>